import { Breakpoints as DSBreakpoints } from '@picsart/design-system/foundation/responsive';

export const Breakpoints = {
  SM: `@media (min-width: ${DSBreakpoints.sm}px)`,
  MD: `@media (min-width: ${DSBreakpoints.md}px)`,
  LG: `@media (min-width: ${DSBreakpoints.lg}px)`,
  XL: `@media (min-width: ${DSBreakpoints.xl}px)`,
  XXL: `@media (min-width: ${DSBreakpoints.xxl}px)`,
} as const;
